<template>
	<div class="page-login">
		<div class="container" v-if="!showErrorInformation">
			<div class="login-logo text-center">
				<img src="/img/logo/grafias_medium_ondark.png" class="d-inline-block m-auto" loading="lazy" alt="Grafias">
			</div>
			<div class="message-box text-center" v-if="!isVerified">
				<div class="message-box-icon flex-center mb-5">
					<div class="white-dot"></div>
				</div>
				<h3 class="mb-4">{{ $t('Activating your account') }}</h3>
				<div class="text-lg mb-4">
					Please wait for a few seconds while we prepare<br>all the stuff you need to get started
				</div>
			</div>
			<div class="message-box text-center" v-if="isVerified">
				<div class="message-box-icon flex-center text-center mb-5">
					<!-- <div class="white-dot"></div> -->
					<i class="material-icons d-block m-auto md-36 text-success">check</i>
				</div>
				<h3 class="mb-4">{{ $t('All set and ready to go') }}</h3>
				<router-link
					to="/login"
					class="btn btn-submit btn-primary mt-3">
					{{ $t('Log In') }}
				</router-link>
			</div>
		</div>
		<div class="message-box text-center" v-if="showErrorInformation">
			<div class="login-logo text-center mb-0">
				<img src="/img/logo/grafias_medium_ondark.png" class="d-inline-block m-auto" loading="lazy" alt="Grafias">
			</div>
			<img src="/img/OOPS.png" class="d-inline-block m-auto" loading="lazy" alt="Grafias">
			<span>
				<h3 class="mb-5 mt-4 text-center">{{ messageError }},
				<router-link
					to="/login"
					class="primary-text pb-1">
					{{ $t('click here to access Grafi.as') }}
				</router-link></h3>
			</span>
		</div>
	</div>
</template>

<script>
import { mapActions } from 'vuex';
import auth from '@/api/auth';
import { getAxiosErrorMessage } from '../lib/helper';

export default {
	name: 'AutoLogin',
	data() {
		return {
			isValidating: true,
			loginError: null,
			isResetPasswordVisible: false,
			password: '',
			confirmPassword: '',
			isResetting: false,
			isVerified: false,
			showErrorInformation: false,
			messageError: '',
		};
	},
	methods: {
		...mapActions({
			setLoggedIn: 'setLoggedIn',
		}),
		validateToken() {
			this.isValidating = true;
			const params = {
				token: this.token,
				lang: 'en',
			};
			const callback = () => {
				this.isValidating = false;
				this.isVerified = true;
			};
			const errorCallback = (e) => {
				const message = getAxiosErrorMessage(e);
				// this.$notify({
				// 	group: 'app',
				// 	type: 'error',
				// 	title: 'Verifying',
				// 	text: message,
				// });
				this.messageError = message;
				this.showErrorInformation = true;
				this.isValidating = false;
			};
			auth.verify(params, callback, errorCallback);
		},
	},
	computed: {
		token() {
			const { token } = this.$route.query;
			return token;
		},
		email() {
			const { email } = this.$route.query;
			return email;
		},
	},
	created() {
		this.validateToken();
	},
};
</script>
